export {default as dispatch} from "./src/dispatch";



//////////////////
// WEBPACK FOOTER
// ./~/d3-dispatch/index.js
// module id = 419
// module chunks = 3